<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title class="text-white"></ion-title>
        <ion-buttons slot="start" :class="{
          'mr-4' : canGoBack
        }">
          <ion-button v-if="canGoBack" @click="goBack" class="bg-brand-dark-gray rounded-md">
            <svg class="" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 11.9961H18" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M12 18L6 12L12 6" stroke="white" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round"/>
            </svg>
          </ion-button>
        </ion-buttons>
        <div class="flex w-full">
          <div class="w-full rounded-full bg-brand-dark-gray h-2 overflow-hidden">
            <div
                :style="{
                  'width': `${progress}%`
                }"
                class="h-full bg-brand-lime transition-all rounded-full"></div>
          </div>
        </div>
      </ion-toolbar>
    </ion-header>
    <ion-content>
      <ion-router-outlet  id="onboardingOutlet" class="z-10"></ion-router-outlet>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonPage,
  IonTitle,
  IonToolbar,
  onIonViewDidEnter,
  IonButton,
  IonInput,
  IonRouterOutlet, useIonRouter
} from '@ionic/vue';
import {computed, defineComponent, onMounted, onUnmounted, PropType, ref, Ref, watch} from 'vue';
import {StatusBar, Style} from "@capacitor/status-bar";
import {useRouter} from "vue-router";
import {Observable, ObservableEvent} from "@/services/observable/Observable";

export default defineComponent({
  name: 'AccountOnboardingRouterOutlet',
  props: {
    onboardingStep: {
      type: Object as PropType<Ref<number>>,
      required: true
    },
  },
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonButtons,
    IonButton,
    IonRouterOutlet,
    IonContent
  },
  setup(props) {

    const canGoBack = ref(false)
    const ionRouter = useIonRouter()

    const observer = ref()

    onMounted(()=>{
      observer.value = Observable.subscribe((response:any)=>{
        if (response.event === ObservableEvent.IonRouterOutletChanged) {
          canGoBack.value = response.data
        }
      })
    })

    onUnmounted(()=>{
      observer.value?.unsubscribe()
    })

    const goBack = async () => {
      await ionRouter.back()
    }

    const progress = computed(()=>{
      return (props.onboardingStep.value / 9) * 100
    })

    return {goBack, progress, canGoBack}

  }
});
</script>
